import * as pConst from "../consts/profiles-consts.js";
import * as wConst from "../consts/website-consts.js";

export const InitState = {
  AgencyList: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AgencyPages: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    },
    AgencyCache: []
  }
};

export const agencyReducer = (state = InitState, action) => {
  const ResetState = {
    AgencyList: {
      Loaded: false,
      Result: {
        Code: 500,
        Message: "There is no results yet"
      }
    },
    AgencyPages: {
      Loaded: false,
      Result: {
        Code: 500,
        Message: "There is no results yet"
      },
      AgencyCache: []
    }
  };

  switch (action.type) {
    case wConst.ACTION_FETCH_AGENCYLIST_PENDING: {
      state = {...state, AgencyList: {...state.AgencyList, Loaded: false}};
      break;
    }
    case wConst.ACTION_FETCH_AGENCYLIST_REJECTED: {
      state = {...state, AgencyList: {Result: action.payload, Loaded: true}};
      break;
    }
    case wConst.ACTION_FETCH_AGENCYLIST_FULLFILLED: {
      state = {...state, AgencyList: {Result: action.payload, Loaded: true}};
      break;
    }
    case wConst.ACTION_FETCH_AGENCYPROFILE_PENDING: {
      state = {...state, AgencyPages: {...state.AgencyPages, Loaded: false}};
      break;
    }
    case wConst.ACTION_FETCH_AGENCYPROFILE_REJECTED: {
      state = {...state, AgencyPages: {Result: action.payload, Loaded: true}};
      break;
    }
    case wConst.ACTION_FETCH_AGENCYPROFILE_FULLFILLED: {
      //console.log(action)
      state = {...state, AgencyPages: {Result: action.payload, Loaded: true}};
      break;
    }
  }
  return state;
};


